export default __webpack_public_path__ + "static/media/Artwork_gmx.18d1eb6c.svg";